import React from "react";
import { SwitchInput } from "../components";
import { Checkbox, EmailInput, Button, ProfilePaymentIcon } from "@components";

const KlarnaSettings = ({
  merchant,
  control,
  errors,
  watch,
  klarnaAccountEmail,
  onEnableSubmit,
}) => {
  if (!merchant) return null;

  const [loading, setLoading] = React.useState(false);
  const [errorMsg, setErrorMsg] = React.useState("");

  const email = watch("klarnaEmail");

  const emailRegex = /^\S+@\S+\.\S+$/;
  const isValidEmail = emailRegex.test(email || "");
  const isButtonDisabled = loading || !isValidEmail;

  const handleEnable = async () => {
    setErrorMsg("");
    setLoading(true);
    try {
      await onEnableSubmit(email);
    } catch (err) {
      console.error(err);
      setErrorMsg("Something went wrong. Please try again or contact support.");
    } finally {
      setLoading(false);
    }
  };

  const klarnaRate = (
    (merchant?.contract?.klarnaProcessingRate ?? 0.0349) * 100
  ).toFixed(2);

  return (
    <div className="rounded-3xl bg-white shadow-[4px_4px_16px_0px_rgba(0,0,0,0.16)] py-8 px-6 w-full">
      <div className="flex items-start gap-4">
        <ProfilePaymentIcon paymentType="Klarna" />
        <div className="flex-1">
          <div className="flex items-start justify-between gap-4">
            <div>
              <p className="text-sm font-medium text-zinc-900">Klarna</p>
              <p className="text-sm/6 text-zinc-500 mt-0.5">
                {klarnaAccountEmail ? "Available" : "Only available"} for Cash
                sales and E-commerce payments, not Trade.
                <ol className="list-decimal list-inside mt-1">
                  <li>
                    There is a flat <strong>{klarnaRate}% fee</strong> per
                    transaction (billed at month-end).
                  </li>
                  <li>
                    Goods need to be{" "}
                    <strong>
                      shipped within 24 hours of capturing the payment.
                    </strong>
                  </li>
                </ol>
              </p>
            </div>
            {klarnaAccountEmail && (
              <SwitchInput name="klarnaEnabled" control={control} disabled />
            )}
          </div>

          {!klarnaAccountEmail && (
            <div className="mt-3">
              <p className="text-sm/6 text-zinc-500 mb-2">
                To get started, Klarna requires an email. This is used to access
                Klarna's merchant portal & receive customer support / dispute
                queries.
              </p>
              <div className="flex items-center gap-x-3">
                <div className="flex-1">
                  <EmailInput
                    name="klarnaEmail"
                    required
                    placeholder="Enter an email to start using Klarna"
                    control={control}
                    errors={errors.klarnaEmail}
                  />
                </div>
                <Button
                  onClick={handleEnable}
                  color="primary"
                  disabled={isButtonDisabled}
                >
                  {loading ? "Enabling…" : "Enable Klarna"}
                </Button>
              </div>
              {errorMsg && (
                <p className="text-red-600 text-sm mt-2">{errorMsg}</p>
              )}
            </div>
          )}

          {klarnaAccountEmail && (
            <div className="mt-4">
              <p className="text-xs/6 text-zinc-500">
                Account email: {klarnaAccountEmail} ·{" "}
                <span>Contact Klarna to change.</span>
              </p>
            </div>
          )}
        </div>
      </div>
    </div>
  );
};

export default KlarnaSettings;
